export const SDK_NAME = 'sentry.javascript.node';
export const SDK_VERSION = '4.5.3';
